"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var processor_exports = {};
__export(processor_exports, {
  MessageProcessor: () => MessageProcessor,
  NotificationContextProcessor: () => NotificationContextProcessor,
  NotificationProcessor: () => NotificationProcessor
});
module.exports = __toCommonJS(processor_exports);
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_patch = require("./patch");
var import_utils = require("./utils");
class MessageProcessor {
  static {
    __name(this, "MessageProcessor");
  }
  static createFromEvent(event, id) {
    const messageId = event.messageId ?? id;
    if (messageId == null) throw new Error("Message id is required");
    return {
      id: messageId,
      cardId: event.cardId,
      type: event.messageType,
      content: event.content,
      extra: event.extra,
      creator: event.socialId,
      created: event.date ?? /* @__PURE__ */ new Date(),
      removed: false,
      reactions: [],
      attachments: []
    };
  }
  static applyPatchEvent(message, patchEvent, allowedPatchTypes) {
    const patches = this.eventToPatches(patchEvent).filter((it) => it.messageId === message.id);
    return (0, import_patch.applyPatches)(message, patches, allowedPatchTypes);
  }
  static eventToPatches(event) {
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.UpdatePatch: {
        return [
          {
            messageId: event.messageId,
            type: import_communication_types.PatchType.update,
            creator: event.socialId,
            created: event.date ?? /* @__PURE__ */ new Date(),
            data: {
              content: event.content,
              extra: event.extra
            }
          }
        ];
      }
      case import_communication_sdk_types.MessageEventType.RemovePatch:
        return [
          {
            messageId: event.messageId,
            type: import_communication_types.PatchType.remove,
            creator: event.socialId,
            created: event.date ?? /* @__PURE__ */ new Date(),
            data: {}
          }
        ];
      case import_communication_sdk_types.MessageEventType.ReactionPatch:
        return [
          {
            messageId: event.messageId,
            type: import_communication_types.PatchType.reaction,
            creator: event.socialId,
            created: event.date ?? /* @__PURE__ */ new Date(),
            data: {
              operation: event.operation.opcode,
              reaction: event.operation.reaction
            }
          }
        ];
      case import_communication_sdk_types.MessageEventType.BlobPatch:
        return event.operations.map((it) => blobOperationToPatchData(it)).filter((x) => x != null).map((it) => ({
          messageId: event.messageId,
          type: import_communication_types.PatchType.attachment,
          creator: event.socialId,
          created: event.date ?? /* @__PURE__ */ new Date(),
          data: it
        }));
      case import_communication_sdk_types.MessageEventType.AttachmentPatch:
        return event.operations.map((it) => attachmentOperationToPatchData(it)).filter((x) => x != null).map((it) => ({
          messageId: event.messageId,
          type: import_communication_types.PatchType.attachment,
          creator: event.socialId,
          created: event.date ?? /* @__PURE__ */ new Date(),
          data: it
        }));
      case import_communication_sdk_types.MessageEventType.ThreadPatch: {
        const data = threadOperationToPatchData(event.operation);
        if (data == null) return [];
        return [
          {
            messageId: event.messageId,
            type: import_communication_types.PatchType.thread,
            creator: event.socialId,
            created: event.date ?? /* @__PURE__ */ new Date(),
            data
          }
        ];
      }
    }
  }
}
class NotificationContextProcessor {
  static {
    __name(this, "NotificationContextProcessor");
  }
  static createFromEvent(event, id) {
    const contextId = event.contextId ?? id;
    if (contextId == null) {
      throw new Error("Notification context id is required");
    }
    return {
      id: contextId,
      cardId: event.cardId,
      account: event.account,
      lastView: event.lastView,
      lastUpdate: event.lastUpdate,
      lastNotify: event.lastNotify,
      notifications: (0, import_utils.withTotal)([])
    };
  }
  static updateFromEvent(context, event) {
    if (context.account !== event.account || context.id !== event.contextId) return context;
    return {
      ...context,
      lastView: event.updates.lastView ?? context.lastView,
      lastUpdate: event.updates.lastUpdate ?? context.lastUpdate,
      lastNotify: event.updates.lastNotify ?? context.lastNotify
    };
  }
  static removeFromEvent(context, event) {
    if (context.account !== event.account || context.id !== event.contextId) return context;
    return void 0;
  }
}
class NotificationProcessor {
  static {
    __name(this, "NotificationProcessor");
  }
  static createFromEvent(event, id) {
    const notificationId = event.notificationId ?? id;
    if (notificationId == null) {
      throw new Error("Notification id is required");
    }
    return {
      id: notificationId,
      cardId: event.cardId,
      contextId: event.contextId,
      account: event.account,
      type: event.notificationType,
      read: event.read,
      content: event.content ?? {},
      created: event.date ?? /* @__PURE__ */ new Date(),
      messageId: event.messageId,
      messageCreated: event.messageCreated
    };
  }
}
function blobOperationToPatchData(operation) {
  if (operation.opcode === "attach") {
    return {
      operation: "add",
      attachments: operation.blobs.map((it) => ({
        id: it.blobId,
        type: it.mimeType,
        params: it
      }))
    };
  } else if (operation.opcode === "detach") {
    return {
      operation: "remove",
      ids: operation.blobIds
    };
  } else if (operation.opcode === "set") {
    return {
      operation: "set",
      attachments: operation.blobs.map((it) => ({
        id: it.blobId,
        type: it.mimeType,
        params: it
      }))
    };
  } else if (operation.opcode === "update") {
    return {
      operation: "update",
      attachments: operation.blobs.map((it) => ({
        id: it.blobId,
        params: it
      }))
    };
  }
  return void 0;
}
__name(blobOperationToPatchData, "blobOperationToPatchData");
function attachmentOperationToPatchData(operation) {
  if (operation.opcode === "add") {
    return {
      operation: "add",
      attachments: operation.attachments
    };
  } else if (operation.opcode === "remove") {
    return {
      operation: "remove",
      ids: operation.ids
    };
  } else if (operation.opcode === "set") {
    return {
      operation: "set",
      attachments: operation.attachments
    };
  } else if (operation.opcode === "update") {
    return {
      operation: "update",
      attachments: operation.attachments
    };
  }
  return void 0;
}
__name(attachmentOperationToPatchData, "attachmentOperationToPatchData");
function threadOperationToPatchData(operation) {
  if (operation.opcode === "attach") {
    return {
      operation: "attach",
      threadId: operation.threadId,
      threadType: operation.threadType
    };
  } else if (operation.opcode === "update") {
    return {
      operation: "update",
      threadId: operation.threadId,
      repliesCountOp: operation.updates.repliesCountOp,
      lastReply: operation.updates.lastReply
    };
  }
  return void 0;
}
__name(threadOperationToPatchData, "threadOperationToPatchData");
//# sourceMappingURL=processor.js.map
